<template>
  <transition
    v-if="path"
    name="fade"
  >
    <div class="editor">
      <draggable-resizeable
        :drag-handle="'header'"
        :active="true"
        :w="640"
        :h="640"
        :x="posX"
        :y="posY"
        :minw="640"
        :minh="360"
      >
        <header>
          <close
            size="s"
            @click="close"
          />
        </header>
        <div class="body scroll-y">
          <template v-for="(field, key) in fields">
            <component
              v-if="field.input && (field.condition === undefined || field.condition(values, $store.getters.path))"
              :is="editor(field.input)"
              :key="$store.getters.path + '#' + key"
              :name="key"
              v-bind="field"
              :value="values[key]"
              @input="save(key, $event)"
            >
              <span v-html="t(field.label)" />
            </component>
          </template>
        </div>
      </draggable-resizeable>
    </div>
  </transition>
</template>

<script>
import Checkbox from '@/components/editor/input/Checkbox'
import Color from '@/components/editor/input/Color'
import Form from '@/components/editor/input/Form'
import HTML from '@/components/editor/input/HTML'
import Heading from '@/components/editor/input/Heading'
import Help from '@/components/editor/input/Help'
import Link from '@/components/editor/input/Link'
import Radio from '@/components/editor/input/Radio'
import Text from '@/components/editor/input/Text'
import Number from '@/components/editor/input/Number'
import Drop from '@/components/editor/input/Drop'

import Close from '@/components/icons/Close'
import DraggableResizeable from './draggable-resizeable'

import { defaultValues } from '@/components'

const editorLookup = {
  checkbox: Checkbox,
  color: Color,
  form: Form,
  heading: Heading,
  help: Help,
  html: HTML,
  link: Link,
  radio: Radio,
  text: Text,
  number: Number, // TODO: Dangerous! We should rename this, because it overrides prop-type Number
  drop: Drop
}

export default {
  name: 'PropEditor',
  components: {
    DraggableResizeable,
    Close
  },
  data () {
    return {
      $$store: undefined
    }
  },
  methods: {
    t (key, ...values) {
      if (!this.$store.$componentRef) return key
      if (Array.isArray(key)) {
        const [method, ...args] = key
        return this.$store.$componentRef['$' + method](...args)
      }
      return this.$store.$componentRef.$t(key, ...values)
    },
    close () {
      this.$router.replace({ query: { edit: undefined } })
    },
    save (key, value) {
      this.$store.dispatch('setProp', {
        key,
        value
      })
    },
    editor (tag) {
      return editorLookup[tag]
    }
  },
  computed: {
    path () {
      return this.$route.query.edit
    },
    $store: {
      get () {
        return this.$$store.getters.modulesByPath[this.path]
      },
      set (store) {
        this.$$store = store
      }
    },
    posX () {
      return document.documentElement.clientWidth / 2 - 320
    },
    posY () {
      return document.documentElement.clientHeight / 2 - 320
    },
    fields () {
      return this.$store.getters.type.props
    },
    values () {
      return {
        ...defaultValues(this.$store.getters.type),
        ...this.$store.getters.props
      }
    }
  },
  watch: {
    '$store' (newStore) {
      // parent has been removed
      if (!newStore) {
        this.close()
      }
    },
    '$store.$componentRef' () {
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

.editor {
  z-index: z(propEditor) !important;
  position: fixed;
  background-color: rgba($color-main-darker, 0.97);
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5em;
  letter-spacing: 0.5pt;
  box-shadow: 0 0 20px rgba(#000, 0.5);

  .vdr > header {
    pointer-events: auto;
    display: flex;
    justify-content: flex-end;
    background-color: darken($color-main-darker, 5);
    padding: 15px;
    position: sticky;
    top: 0;
    cursor: move;
    height: 54px;
  }

  .body {
    padding: 0 60px 40px 60px;
    display: flex;
    flex-wrap: wrap;
    max-height: calc(100% - 54px); /* minus header height */
  }
}
</style>
